<template>

  <div class="popup-overlay">
    <div style="width: 400px" class="popup">
      <button type="button" class="close-btn" v-on:click="popupBezar">
        <i class="fa fa-close"></i>
      </button>
      <h1>Pontszámok</h1>
      <div v-if="pontok.length > 0">
        <div class="description">
          Rendszeres szociális támogatás és költségtérítés mérséklésre beadott pályázatának bírálati pontszámai.
        </div>
        <div class="point-row" v-for="(pont, i) in pontok">
          <div class="title">
            {{ pont.kategoria }}
          </div>
          <div class="point">
            {{ pont.pontszam }}
          </div>
        </div>
        <div class="point-row sum">
          <div class="title">
            Összpontszám
          </div>
          <div class="point">
            {{ osszpontszam }}
          </div>
        </div>
      </div>
      <div style="padding-bottom: 0px;" class="description" v-else>
        Nem található bírálati pontszám.
      </div>
    </div>
  </div>

</template>

<script>
import Vue from 'vue';

export default {
  components: {
  },

  data: function() {
    return {
      pontok: []
    }
  },

  computed: {
    osszpontszam: function() {
      var p = 0;

      this.pontok.map(function(pont) {
        p += parseInt(pont.pontszam);
      });

      return p;
    }
  },

  mounted: function() {
    this.getPontok();
  },

  methods: {
    popupBezar: function() {
      this.$emit('onClose');
    },

    getPontok: function() {
      var _this = this;
      this.$root.ajax('hatar/rendszeres_szocialis_tamogatas_biralat_pontszamok/' + this.$root.user.neptuncode, {
        method: 'GET',
        success: function(response) {
          if (response.error == false) {
            _this.pontok = response.pontok;

          } else {
            swal('Hiba!', response.error, 'error');
          }
        }
      });
    }
  }
}

</script>


// WEBPACK FOOTER //
// rendszeres_szocialis_pontok.vue?012de450